import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";

export class CompositeDeviceService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
		this._rc = new RealtimeClient();
	}

	/**
	 * Get all compositeDevices
	 * @param {String} type
	 */
	getAllCompositeDevice(callback) {
		const url = `/ecosystem/api/compositeDevices`;
		this._restClient.exec_get(url, callback);
	}

	/**
	 * Get compositeDevice by id
	 * @param {String} type
	 */
	getCompositeDeviceById(compositeDeviceId, callback) {
		const url = `/ecosystem/api/compositeDevices/${compositeDeviceId}`;
		this._restClient.exec_get(url, callback);
	}

	/**
	 * Create a composite device
	 * @param {Object} data
	 */
	createCompositeDevice(data, callback) {
		const url = `/ecosystem/api/compositeDevices`;
		const body = JSON.stringify(data);
		this._restClient.exec_post(url, body, callback);
	}

	/**
	 * Update a composite device
	 * @param {String} id
	 */
	updateCompositeDeviceId(id, data, callback) {
		const url = `/ecosystem/api/compositeDevices/${id}`;
		const body = JSON.stringify(data);
		this._restClient.exec_put(url, body, callback);
	}

	/**
	 * delete a composite device
	 * @param {String} id
	 */
	deleteCompositeDevice(id, callback) {
		const url = `/ecosystem/api/compositeDevices/${id}`;
		this._restClient.exec_delete(url, callback);
	}

	/**
	 * Add single devices or cameras to a composite device.
	 * @param {String} id
	 */
	addCompositeDevices(id, data, callback) {
		const url = `/ecosystem/api/compositeDevices/${id}/addDevices`;
		const body = JSON.stringify(data);
		this._restClient.exec_put(url, body, callback);
	}

	/**
	 * Remove single devices or cameras from a composite device.
	 * @param {String} id
	 */
	removeCompositeDevices(id, data, callback) {
		const url = `/ecosystem/api/compositeDevices/${id}/removeDevices`;
		const body = JSON.stringify(data);
		this._restClient.exec_put(url, body, callback);
	}

	subscribeCompositeDevices(callback) {
		this._rc.subscribe("ecosystem", "/compositeDevices", {}, function (msg) {
			const response = JSON.parse(msg);
			if (response) {
				callback(null, response);
			}
		});
	}
}
